import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Navbar = ({ isHome = false }) => {
  const { t, i18n } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sobreDropdownOpen, setSobreDropdownOpen] = useState(false);
  const [recursosDropdownOpen, setRecursosDropdownOpen] = useState(false);
  const [opaque, setOpaque] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  // Função para navegar com scroll suave para âncora
  const handleNavigation = (path, anchor = null) => {
    // Fechar todos os dropdowns
    setDropdownOpen(false);
    setSobreDropdownOpen(false);
    setRecursosDropdownOpen(false);

    if (anchor && location.pathname === path) {
      // Se já estamos na página, apenas faz scroll para a âncora
      scrollToAnchor(anchor);
    } else if (anchor) {
      // Armazena a âncora no localStorage para ser usada após o redirecionamento
      localStorage.setItem("scrollToAnchor", anchor);
      window.location.href = path;
    } else {
      // Navegação normal com redirecionamento completo
      window.location.href = path;
    }
  };

  const scrollToAnchor = (anchor) => {
    const element = document.getElementById(anchor);
    if (element) {
      const offsetTop = element.offsetTop - 100; // Ajuste para a altura da navbar
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };
  const handleLogoClick = () => {
    if (location.pathname === "/") {
      const banner = document.getElementById("banner-home");
      if (banner) {
        window.scrollTo({
          top: banner.offsetTop - 80,
          behavior: "smooth",
        });
      }
    } else {
      window.location.href = "/";
    }
  };

  useEffect(() => {
    if (!isHome) {
      setOpaque(true);
      return;
    }
    const handleScroll = () => {
      // Consider banner height as 500px (from BannerCarousel.css)
      if (window.scrollY > 380) {
        setOpaque(true);
      } else {
        setOpaque(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  // Efeito para verificar se há uma âncora armazenada no localStorage
  useEffect(() => {
    const anchor = localStorage.getItem("scrollToAnchor");
    if (anchor) {
      // Limpar o localStorage
      localStorage.removeItem("scrollToAnchor");
      // Aguardar um momento para o DOM carregar completamente
      setTimeout(() => scrollToAnchor(anchor), 500);
    }
  }, [location.pathname]); // Executar sempre que a localização mudar

  return (
    <nav className={`navbar${opaque ? " navbar-opaque" : ""}`}>
      <div
        className="navbar-logo"
        style={{ cursor: "pointer" }}
        onClick={handleLogoClick}
      >
        <img src="/assets/img/logo.png" alt="Logo" />
      </div>
      <button
        className="navbar-hamburger"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      >
        <span className="hamburger-bar"></span>
        <span className="hamburger-bar"></span>
        <span className="hamburger-bar"></span>
      </button>
      <ul
        className={`navbar-links${
          mobileMenuOpen ? " navbar-links-mobile-open" : ""
        }`}
      >
        {/* Dropdown Produtos */}
        <li
          className="dropdown"
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
        >
          <span className="dropdown-title">
            {t("navbar.products")} <i className="dropdown-arrow">▼</i>
          </span>
          <ul className={`dropdown-menu${dropdownOpen ? " show" : ""}`}>
            <li>
              <a
                href="/cuidados-saude-atencao-primaria"
                className="dropdown-link"
                onClick={() => setDropdownOpen(false)}
              >
                {t("navbar.products.platform1")}
              </a>
            </li>
            <li>
              <a
                href="/reproducao-humana-assistida"
                className="dropdown-link"
                onClick={() => setDropdownOpen(false)}
              >
                {t("navbar.products.platform2")}
              </a>
            </li>
          </ul>
        </li>
        {/* Dropdown Sobre */}
        <li
          className="dropdown"
          onMouseEnter={() => setSobreDropdownOpen(true)}
          onMouseLeave={() => setSobreDropdownOpen(false)}
        >
          <span className="dropdown-title">
            {t("navbar.about")} <i className="dropdown-arrow">▼</i>
          </span>
          <ul className={`dropdown-menu${sobreDropdownOpen ? " show" : ""}`}>
            {" "}
            <li>
              <a
                href="/sobre"
                className="dropdown-link"
                onClick={() => {
                  setSobreDropdownOpen(false);
                  if (location.pathname === "/sobre") {
                    scrollToAnchor("banner-sobre");
                  } else {
                    localStorage.setItem("scrollToAnchor", "banner-sobre");
                  }
                }}
              >
                {t("navbar.about.aboutDsiacdata")}
              </a>
            </li>
            <li>
              <button
                className="dropdown-link"
                onClick={() => handleNavigation("/sobre", "nossa-missao")}
              >
                {t("navbar.about.mission")}
              </button>
            </li>
            <li>
              <button
                className="dropdown-link"
                onClick={() => handleNavigation("/sobre", "nossa-historia")}
              >
                {t("navbar.about.history")}
              </button>
            </li>
          </ul>
        </li>
        {/* Dropdown Recursos */}
        <li
          className="dropdown"
          onMouseEnter={() => setRecursosDropdownOpen(true)}
          onMouseLeave={() => setRecursosDropdownOpen(false)}
        >
          <span className="dropdown-title">
            {t("navbar.resources")} <i className="dropdown-arrow">▼</i>
          </span>
          <ul className={`dropdown-menu${recursosDropdownOpen ? " show" : ""}`}>
            {" "}
            <li>
              <a
                href="/recursos"
                className="dropdown-link"
                onClick={() => {
                  setRecursosDropdownOpen(false);
                  if (location.pathname === "/recursos") {
                    scrollToAnchor("banner-recursos");
                  } else {
                    localStorage.setItem("scrollToAnchor", "banner-recursos");
                  }
                }}
              >
                {t("navbar.resources.resourceCenter")}
              </a>
            </li>
            <li>
              <button
                className="dropdown-link"
                onClick={() =>
                  handleNavigation("/recursos", "recursos-principais")
                }
              >
                {t("navbar.resources.news")}
              </button>
            </li>
            <li>
              <button
                className="dropdown-link"
                onClick={() => handleNavigation("/recursos", "faq-section")}
              >
                {t("navbar.resources.faq")}
              </button>
            </li>
          </ul>
        </li>{" "}
        <li className="navbar-btn-li">
          <a href="/solicitar-reuniao" className="navbar-btn">
            {t("navbar.contact")}
          </a>
        </li>
        <li className="navbar-lang-toggle">
          <button
            onClick={() =>
              i18n.changeLanguage(i18n.language === "en" ? "pt" : "en")
            }
            className="lang-toggle-btn language-toggle"
            aria-label={
              i18n.language === "en"
                ? "Mudar para Português"
                : "Switch to English"
            }
          >
            <span className="language-toggle-label">
              {i18n.language === "en" ? "EN" : "PT"}
            </span>
            <span
              className={`language-toggle-switch${
                i18n.language === "en"
                  ? " language-toggle-en"
                  : " language-toggle-pt"
              }`}
            >
              <span className="language-toggle-knob" />
            </span>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
